/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fetcher } from 'openapi-typescript-fetch'
import type { paths } from '@/api/swagger/api'
import { addToken } from './middlewares/addToken'

interface RequestConfig {
  method: 'GET' | 'PUT' | 'PATCH' | 'POST' | 'DELETE'
  url: string
  params?: any
  data?: any
  headers?: any
  signal?: AbortSignal
}

const _fetcher = Fetcher.for<paths>()
_fetcher.configure({
  baseUrl:
    import.meta.env.VITE_USE_PROXY === 'true'
      ? '/api'
      : import.meta.env.VITE_API_URL || '',
  init: {
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  },
  use: [addToken],
})

export const fetcher = <R>(
  { method, url, data, params, signal }: RequestConfig,
  options?: Parameters<typeof fetch>[1],
) => {
  return _fetcher
    .path(url as any)
    .method(method.toLowerCase())
    .create()({ ...data, ...params }, { signal, ...options })
    .then((r) => r.data as R)
}
